module.exports = __webpack_public_path__ + "img/there-there.df5ca9c9.png";